import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const InviteValidation = ({ inviteDetails, roleSelected }) => {
  const isCashier = roleSelected !== "Owner";

  const InviteSchema = yup.object({
    email: yup
      .string()
      .email("Invalid email address")
      .required("Email is required"),

    phoneNumber: yup
      .string()
      .matches(/^[0-9]+$/, "Phone number must contain only digits")
      .test("num", "Invalid phone number format", (val) => !val.startsWith("0"))
      .min(9, "Invalid phone number format")
      .max(11, "Invalid phone number format")
      .required("Phone number is required"),

    role: yup.string().required("Role is required"),

    businessId: yup
      .array()
      .required("Account is required")
      .min(1, "Account is required")
      .nullable(),

    storeId: yup.array().nullable(),

    firstName: isCashier
      ? yup.string().required("First name is required")
      : yup.string().notRequired(),

    lastName: isCashier
      ? yup.string().required("Last name is required")
      : yup.string().notRequired(),
  });

  return useForm({
    resolver: yupResolver(InviteSchema),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: {
      email: inviteDetails?.email || "",
      phoneNumber: inviteDetails?.PhoneNumber || "",
      role: inviteDetails?.role || "",
      businessId: inviteDetails?.businessId || [],
      storeId: inviteDetails?.storeId || [],
      firstName: inviteDetails?.firstName || "",
      lastName: inviteDetails?.lastName || "",
    },
  });
};

export default InviteValidation;
